import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { alpha, styled } from '@mui/material';
import Button from 'components/Button';
import { Row } from 'components/Layout';
import Spacing from 'components/Spacing';
import { CalendarDay } from 'further-ui/utils';
import { ReactNode, useState } from 'react';

type Props = {
  children: ReactNode;
  showFutureTransactionsMessage?: boolean;
  bankOperationDate: CalendarDay;
  sourceActionDate?: CalendarDay;
};

const StyledAlert = styled(Row)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.info.main, 0.2),
  padding: theme.spacing(3),
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));

const ExpandButton = styled(Button)({
  padding: 0,

  '&:hover': {
    backgroundColor: 'transparent',
  },
});

const SourceTransactionsContainer: React.FC<Props> = ({
  children,
  showFutureTransactionsMessage,
  bankOperationDate,
  sourceActionDate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const futureTransactionsMessage = sourceActionDate?.isAfter(bankOperationDate)
    ? 'As this future transaction was booked without an FX rate, the source transaction FX rate will be booked to equal the FX rate at cash settlement.'
    : "As this past transaction was booked without an FX rate, the source transaction will be booked with the FX rate as at the transaction's ledger date";

  return showFutureTransactionsMessage ? (
    <Spacing>
      <StyledAlert fullWidth centered justify="space-between">
        <div>{futureTransactionsMessage}</div>
        <ExpandButton
          variant="text"
          color="primary"
          onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
          endIcon={isExpanded ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}
        >
          Show source transaction
        </ExpandButton>
      </StyledAlert>
      {isExpanded && children}
    </Spacing>
  ) : (
    <Spacing>
      <div>
        <ExpandButton
          variant="text"
          color="primary"
          onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
          endIcon={isExpanded ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}
        >
          Show source transaction
        </ExpandButton>
      </div>
      {isExpanded && children}
    </Spacing>
  );
};

export default SourceTransactionsContainer;
